import EventTypeListItem from './EventTypeListItem';

export default EventTypeListItem;
